'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const usePageTransition = ({
  onEnter,
  onExit,
}: {
  onEnter?: () => void;
  onExit?: () => void;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    onEnter?.();

    return () => {
      onExit?.();
    };
  }, [pathname, searchParams]);
};
